import { ApiEndPoint } from './apiEndPoint'

export const getAccountLicenseInfo = new ApiEndPoint('account/license-info')
export const getAccountLicenses = new ApiEndPoint('account/licenses')
export const getAccountInvoices = new ApiEndPoint('account/invoices')
export const downloadInvoice = new ApiEndPoint('account/invoices/{invoiceId}')
export const getPaymentInformation = new ApiEndPoint('account/payment-information')
export const getMandate = new ApiEndPoint('account/mandate')

